import { Link } from "react-router-dom";
import { List, ListInlineItem } from "reactstrap";
import { UserSocialData } from "../../../../../Data/Applications/Users/Users";

const UserSocialMedia = () => {
  return (
    <div className="social-media">
      <List type="inline" className="align-items-center">
        {UserSocialData.map(({ link, icon }, index) => (
          <ListInlineItem key={index}>
            <Link to={link} target="_blank"><i className={icon}></i></Link>
          </ListInlineItem>
        ))}
      </List>
    </div>
  );
};

export default UserSocialMedia;
